export const steps = [
  {
    moduleName: 'eligibility',
    accordionName: 'Eligibility',
    color: '#56B3EB',
    title: "You're on your way!",
    steps: [
      {
        name: '',
      },
      {
        name: 'persona',
      },
      {
        name: 'school' || 'findSchool',
      },
      {
        name: 'schoolName',
      },
      {
        name: 'degree',
      },
      {
        name: 'citizenship',
      },
      {
        name: 'confirm',
      },
      {
        name: 'process',
      },
    ],
  },
  {
    moduleName: 'personal',
    accordionName: 'Personal',
    color: '#FFCB4C',
    title: 'Great start! XX minutes to go.',
    backendModuleName: 'personal_information',
    steps: [
      {
        name: '',
      },
      {
        name: 'email',
      },
      {
        name: 'phone',
      },
      {
        name: 'address',
      },
      {
        name: 'mailingAddress',
      },
      {
        name: 'maritalStatus',
      },
      {
        name: 'immigrationStatus',
      },
      {
        name: 'visa',
      },
      {
        name: 'reference',
      },
      {
        name: 'disclosure',
      },
    ],
  },
  {
    moduleName: 'education',
    accordionName: 'Education',
    backendModuleName: 'educational_information',
    color: '#DF5F43',
    title: 'Keep it up! XX minutes to go.',
    steps: [
      {
        name: '',
      },
      {
        name: 'type',
        isDateGreaterThanToday: true,
      },
      {
        name: 'grade',
        lightSegIneligible: true,
      },
      {
        name: 'enrollment',
        lightSegIneligible: true,
      },
      {
        name: 'rewind',
        lightSegIneligible: true,
      },
      {
        name: 'test',
        lightSegIneligible: true,
      },
      {
        name: 'score',
        lightSegIneligible: true,
      },
    ],
  },
  {
    moduleName: 'employment',
    accordionName: 'Employment',
    backendModuleName: 'employment_information',
    color: '#5A6973',
    title: 'Nice progress! XX minutes to go.',
    compLightSegIneligible: false,
    steps: [
      {
        name: '',
        lightSegIneligible: true,
      },
      {
        name: '',
      },
      {
        name: 'experience',
        lightSegIneligible: true,
        childSkipEmploymentTillOffer: true,
      },
      {
        name: 'job',
        lightSegIneligible: true,
        childSkipEmploymentTillOffer: true,
        childSkipEmploymentJob: true,
      },
      {
        name: 'history',
        lightSegIneligible: true,
        childSkipEmploymentTillOffer: true,
      },
      {
        name: 'offer',
        lightSegIneligible: true,
      },
      {
        name: 'congrats',
        lightSegIneligible: true,
      },
      {
        name: 'usgradJob',
      },
    ],
  },
  {
    moduleName: 'finance',
    accordionName: 'Financial',
    backendModuleName: 'financial_information',
    color: '#2D4B91',
    title: 'Almost there! XX minutes to go.',
    steps: [
      {
        name: '',
      },
      {
        name: 'addUserFunding',
      },
      {
        name: 'confirmFinancialPlan',
      },
      {
        name: 'requestedLoanAmount',
      },
      {
        name: 'additionaldebt',
      },
      {
        name: 'submitteddebt',
      },
      {
        name: 'acceptDisclosures',
      },
      {
        name: 'reviewAndSubmit',
      },
      {
        name: 'process',
      },
    ],
  },
  {
    moduleName: 'id-verification',
    accordionName: 'Conditional Offer',
    backendModuleName: 'conditional_offer',
    color: '#43dada',
    title: 'Almost there! XX minutes until your initial decision.',
    steps: [
      {
        name: '',
      },
      {
        name: 'academic-period',
      },
    ],
  },
]

export default steps

export type Steps = typeof steps
